import { useMemo } from "react";
import HttpService from "./httpService";
import nvCookieHelpers from "./cookieService";
import { useTranslation } from "react-i18next";
import gobalization from "../constants/globalization";
import { config } from "../config";
const useHttpService = () => {
    const enviromentURL = () => {
        let envURL = "https://api.store.nvidia.com";
        let host = window.location.hostname;
        if (host.split(".")[0] !== "store" && host !== "marketplace.nvidia.com") {
            envURL = `https://${host.split(".")[0].split("-")[0]}-api.store.nvidia.com`;
        }
        if (host.indexOf("localhost") > -1) {
            envURL = "http://localhost:5000";
        }
        return envURL;
    };

    const API_URL = useMemo(() => enviromentURL(), []);
    const httpService = useMemo(() => new HttpService(API_URL), [API_URL]);

    return httpService;
};


export const useCart = () => {
    const { t } = useTranslation();
    const httpService = useHttpService();
    const sessionexpiredID = nvCookieHelpers.getCookie('session_expired');
    const getCart = async (handleSuccess: (result: any) => void, handleError: (err: string) => void, isInit?: boolean) => {
        console.log('sessionID==>', sessionexpiredID);
        try {
            if (isInit || (sessionexpiredID && !JSON.parse(sessionexpiredID))) {
                const result = await httpService.get("/ucc-software/v2/cart/active");
                let resultLength = Object.keys(result.cartItems).length;
                if (result && resultLength > 0) {
                    handleSuccess(result);
                } else {
                    handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
            } else {
                if (!sessionexpiredID) {
                    handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.error(er);
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        }
    };

    const createCart = async (requestBody: any, headerObj: any, handleSuccess: () => void, handleError: (err: string) => void) => {
        try {
            const result = await httpService.postCart("/ucc-software/v2/cart/active", requestBody, headerObj);
            if (result === 200) {
                handleSuccess();
            } else {
                handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
            }
        } catch (er) {
            console.error(er);
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        }
    }

    const updateCart = async (handleSuccess: (result: any, productId?: number) => void, handleError: (err: string, productId?: number) => void, productId?: string, selectedOption?: number, isDownload?: boolean, shippingOption?: string, coupon?: string, currency?: any, couponApplied?: boolean | undefined) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody = {}
                if (productId && (selectedOption !== undefined && selectedOption !== null)) {
                    cartBody = { cart: { products: [{ productId: productId, quantity: selectedOption }], isDigital: isDownload } };
                } else if (shippingOption !== undefined && shippingOption !== null) {
                    cartBody = { shippingOptionId: shippingOption.toString() };
                } else if (currency) {
                    cartBody = currency;
                } else if (couponApplied) {
                    cartBody = { 'remove_coupon': couponApplied };
                } else {
                    cartBody = { promoCode: coupon || '' };
                }
                const result = await httpService.put("/ucc-software/v2/cart/active", cartBody, headerObj);
                if (result) {
                    if (productId) {
                        handleSuccess(result, Number(productId));
                    } else {
                        handleSuccess(result);
                    }
                }
            } else {
                if (!sessionexpiredID) {
                    if (productId) {
                        handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), Number(productId));
                    } else {
                        handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                    }
                }
                throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.error(er);
            if (productId) {
                handleError('', Number(productId));
            } else {
                handleError('');
            }
            // if (coupon && coupon.length) {
            //     handleError('');
            // } else {
            //     handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
            // }
        }
    };

    const taxExempt = async (taxPayLoad: File, handleTaxSuccess: (result: any) => void, handleTaxError: (e: any) => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                console.log('taxPayLoad==>', taxPayLoad);
                // let headerObj = { "content-type": "multipart/form-data" };
                const formData = new FormData();
                formData.append('file', taxPayLoad);
                const result = await httpService.postFile("/ucc-software/v2/checkout/files", formData);
                console.log("taxExempt==>", result);
                if (result) {
                    handleTaxSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleTaxError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.error(er);
            handleTaxError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        }
    }

    const submitPartnerCart = async (order: any, handleCartSuccess: (result: any) => void, handleCartError: (err: any) => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody = order;
                const result = await httpService.post("/ucc-software/v2/checkout/apply-payment-source", cartBody, headerObj);
                if (result) {
                    handleCartSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleCartError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                throw new Error('User Session has been expired');
            }
        } catch (er: any) {
            console.log(er, er?.error);
            // Check if error has specific code (e.g., postal_code_invalid)
            if (er && er.message.length) {
                let errMsg = JSON.parse(er?.message);
                if (errMsg && errMsg?.error?.code === 'postal_code_invalid') {
                    handleCartError(errMsg?.error);
                } else {
                    handleCartError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
                }
            } else {
                handleCartError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
            }
        }
    }
    const submitCart = async (partner: boolean, order: any, handleCartSuccess: (result: any) => void, handleCartError: (err: any) => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody;
                if (partner) {
                    cartBody = { cart: { ...order.cart, ...gobalization(order.locale, order.brand) } }
                }
                else {
                    cartBody = order
                }
                const result = await httpService.post("/ucc-software/v2/checkout", cartBody, headerObj);
                if (result) {
                    handleCartSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleCartError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er: any) {
            console.log(er, er?.error);
            // Check if error has specific code (e.g., postal_code_invalid)
            if (er && er.message.length) {
                let errMsg = JSON.parse(er?.message);
                if (errMsg && errMsg?.error?.code === 'postal_code_invalid') {
                    handleCartError(errMsg?.error);
                } else {
                    handleCartError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
                }
            } else {
                handleCartError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
            }
        }
    }
    const submitCapatcha = async (orderToken: any, handleCapatchaSuccess: (result: any) => void, handleCapatchaError: () => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody = { "event": orderToken };
                const result = await httpService.post("/ucc-software/v2/checkout/assessments", cartBody, headerObj);
                console.log("submitCapatcha==>", result);
                if (result) {
                    handleCapatchaSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleCapatchaError();
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.log(er);
            handleCapatchaError();
        }
    }

    const submitOrder = async (handleOrderSuccess: (result: any) => void, handleOrderError: (e: any) => void) => {
        try {
            if ((sessionexpiredID && !JSON.parse(sessionexpiredID))) {
                let headerObj = { "content-type": "application/json" };
                const result = await httpService.submitOrderPost("/ucc-software/v2/checkout/submit-cart", '', headerObj);
                console.log('SUBMIT CART',)
                if (result) {
                    handleOrderSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleOrderError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er: any) {
            console.log(er.error);
            if (er && er?.error) {
                handleOrderError(er?.error);
            } else {
                handleOrderError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
            }
        }
    }
    const submitAddress = async (address: any, handleAddressSuccess: (result: any) => void, handleAddressError: (err: any) => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let cartBody = {
                    "address": address,
                    // "languageOptions": {
                    //     "languageCode": "en"
                    // },
                }

                const result = await httpService.postAddress("https://addressvalidation.googleapis.com/v1:validateAddress?key=" + config.mapKey, cartBody);
                console.log("submitAddress==>", result);

                if (result) {
                    handleAddressSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleAddressError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.log('submitAddress error==>', er);
            handleAddressError(er);
        }
    }
    return { getCart, createCart, updateCart, submitCart, submitPartnerCart, taxExempt, submitCapatcha, submitOrder, submitAddress };
};